<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="6">
        <b-card :header="$t('Expired Winning')" style="position:relative">
          <b-form autocomplete="off" ref="cnt"></b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from "moment";
import { errorConf } from "@/shared/notifications";
import FloatingLabel from "@/components/FloatingLabel";

export default {
  name: "lotterySystemPerformance",
  props: ["selectedeid"],
  components: {
    FloatingLabel
  },
  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    if (this.eid != "0" && this.eid != "") {
      this.loadData();
    } else {
      this.$router.push("/lottery-systems-performance");
    }
  },
  data: function() {
    return {
      eid: "",
      details: {}
    };
  },
  methods: {
    loadData() {
      if (this.eid == "") return;

      const loadDet = this.$loading.open({
        container: this.$refs.det
      });

      this.$store
        .dispatch("lotterySystemPerformance/read", this.eid)
        .then(resp => {
          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loadDet.close();
        });
    },
    populateData(r) {
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";
    },
    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },
    mom_unix(val) {
      return moment.unix(val / 1e9);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
